import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReviewComponent } from "./review.component";
import { ChartReviewComponent } from "./review-card/chart-review/bar-chart.component";
import { GirdReviewComponent } from "./review-card/grid-review/grid-review.component";
import { DateFilterReviewComponent } from "./review-card/date-filter-review/date-filter-review.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { FilterItemReviewComponent } from "./review-card/filter-item-review/filter-item-review.component";
import { ChartsModule } from "ng2-charts";
import { StaticSelectReviewComponent } from "./static-select-review/static-select-review.component";
import { RemoteSelectReviewComponent } from "./remote-select-review/remote-select-review.component";
import { KpiWidgetComponent } from "./kpi-widget/kpi-widget.component";
import { BarChartComponent } from "./review-card/charts/bar-chart.component";
import { LineChartComponent } from "./review-card/charts/line-chart.component";
import { DoughnutChartComponent } from "./review-card/charts/doughnut-chart.component";
import { PieChartComponent } from "./review-card/charts/pie-chart.component";
import { KpiReviewComponent } from "./kpi-review/kpi-review.component";
import { FilterNameComponent } from "./filter-name/filter-name.component";

const components = [
  ReviewComponent,
  ChartReviewComponent,
  GirdReviewComponent,
  DateFilterReviewComponent,
  FilterItemReviewComponent,
  StaticSelectReviewComponent,
  RemoteSelectReviewComponent,
  KpiWidgetComponent,
  BarChartComponent,
  LineChartComponent,
  DoughnutChartComponent,
  PieChartComponent,
  KpiReviewComponent,
  FilterNameComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components, ChartsModule],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule.forRoot(), SepidzGridModule, ChartsModule],
})
export class ReportReviewModule {}
